export const HOME = '/'
export const ABOUT = 'about'
export const PROJECTS = 'projects'
export const CONTACT = 'contact'
export const NEWS = 'news'
export const NEWS_DETAIL = 'detail'
export const NEWS_CATEGORY = 'category'
export const SERVICES = 'services'
export const ERROR = '*'